<template>
  <b-modal
    v-model="visible"
    size="lg"
    title="Doanh số giao dịch thanh toán thẻ"
    hide-footer
    centered
  >
    <div class="p-3">
      <bar-chart ref="barChart" :chart-data="chartData" :threshold="threshold">
        <template #header>
          <div class="d-flex justify-content-between align-items-center flex-wrap mb-3">
            <div>
              <h4 class="font-weight-bold mb-1">
                {{ deviceName }} - {{ fieldsQuery.serials.join(', ') }}
              </h4>
              <h5 class="mb-1">{{ merchantName }}</h5>
              <h6 class="text-muted mb-1">{{ merchantEmail }}</h6>
            </div>

            <div class="d-flex flex-column align-items-end mt-2 mt-md-0">
              <div class="mb-1">
                <small class="text-muted">Ngày hiện tại: {{ currentDate }}</small>
              </div>
              <div class="d-flex align-items-center">
                <label class="mb-0 mr-2 text-muted small">Khoảng thời gian:</label>
                <input
                  type="month"
                  class="form-control form-control-sm mr-2"
                  v-model="fieldsQuery.fromDate"
                  style="width: 130px"
                  :disabled="isLoading"
                />
                <span class="mx-1 text-muted">–</span>
                <input
                  type="month"
                  class="form-control form-control-sm"
                  v-model="fieldsQuery.toDate"
                  style="width: 130px"
                  :disabled="isLoading"
                />
                <b-button
                  size="sm"
                  variant="primary"
                  class="ml-2"
                  @click="fetchDataChart"
                  :disabled="isLoading"
                >
                  <b-spinner small v-if="isLoading"></b-spinner>
                  {{ isLoading ? 'Đang tải...' : 'Áp dụng' }}
                </b-button>
              </div>
            </div>
          </div>
        </template>

        <template #footer>
          <div class="text-center mt-3">
            <small class="text-muted">{{ displayDateRange }}</small>
          </div>

          <div class="text-center mt-3 legend">
            <span class="legend-item mr-3">
              <span class="legend-box bg-success"></span>
              Đạt TPV (≥ {{ threshold.toLocaleString() }})
            </span>
            <span class="legend-item">
              <span class="legend-box bg-danger"></span>
              Chưa đạt TPV
            </span>
          </div>
        </template>
      </bar-chart>
    </div>
  </b-modal>
</template>

<script>
  import BarChart from '@/components/BarChart.vue'
  import { DeviceService } from '@/services/device.service'
  import moment from 'moment'

  export default {
    name: 'TransactionChartModal',
    components: { BarChart },
    data() {
      return {
        fieldsQuery: {
          serials: [],
          merchantMnpIds: [],
          fromDate: '',
          toDate: '',
          reportType: '',
        },
        visible: false,
        isLoading: false,
        merchantName: '',
        merchantEmail: '',
        deviceName: '',
        threshold: 0,
        chartData: { labels: [], datasets: [] },
      }
    },

    computed: {
      currentDate() {
        return moment().format('DD/MM/YYYY')
      },
      displayDateRange() {
        const labels = this.chartData.labels
        if (!labels.length) return ''
        return `${labels[0]} - ${labels[labels.length - 1]}`
      },
    },

    methods: {
      async openModal(payload) {
        this.mapInfor(payload)
        this.mapFieldQuery(payload)
        this.threshold = payload.threshold || 0
        this.visible = true
        await this.fetchDataChart()
      },

      updateChart(labels, values) {
        this.chartData.labels = labels
        this.chartData.datasets = [
          {
            label: 'Doanh số',
            borderRadius: 8,
            barThickness: 40,
            data: values,
          },
        ]
      },

      mapInfor(infor) {
        const { merchantName, merchantEmail, deviceName } = infor
        this.merchantName = merchantName || ''
        this.merchantEmail = merchantEmail || ''
        this.deviceName = deviceName || ''
      },

      mapFieldQuery(payload) {
        const { serials, merchantMnpIds, fromDate, toDate, reportType } = payload
        this.fieldsQuery.serials = serials || []
        this.fieldsQuery.merchantMnpIds = merchantMnpIds || []
        this.fieldsQuery.fromDate = fromDate || ''
        this.fieldsQuery.toDate = toDate || ''
        this.fieldsQuery.reportType = reportType || ''
      },

      async fetchDataChart() {
        try {
          this.isLoading = true
          const params = { ...this.fieldsQuery }
          const response = await DeviceService.getDataChartReport(params)
          if (response.code === 1000) {
            const data = response.data || []
            const sortedData = data.sort((a, b) => a.dateReport.localeCompare(b.dateReport))

            const labels = sortedData.map(item => {
              const [year, month] = item.dateReport.split('-')
              return `${month}/${year}`
            })
            const values = sortedData.map(item => item.totalTpv || 0)
            this.updateChart(labels, values)
          }
        } catch (error) {
          this.showFailMx(error.message)
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>

<style scoped>
  .b-modal {
    font-family: 'Inter', sans-serif;
  }

  .legend {
    font-size: 13px;
    color: #6c757d;
  }

  .legend-item {
    display: inline-flex;
    align-items: center;
  }

  .legend-box {
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-right: 6px;
    border-radius: 3px;
  }

  .bg-success {
    background-color: #28a745 !important;
  }

  .bg-danger {
    background-color: #dc3545 !important;
  }

  input[type='month'] {
    border: 1px solid #ced4da;
    border-radius: 6px;
    font-size: 13px;
    padding: 3px 6px;
    color: #495057;
  }

  input[type='month']:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.1);
  }
</style>
